import { prefix } from "../../../design-tokens/meta";
import { types as sortType } from "../../../js/data-grid/sort-by-column";
import { actionTypes } from "../../../js/state-machine/reducers/iterator";
import { events } from "../../../js/state-machine";
import { types } from "../../../js/state-machine/actions";

export const componentName = "TableHeadCell";

// HeadCell classes should override the basic structure of Cell.componentClasses
export const componentClasses = Object.freeze({
    basic: `${prefix}th`,
    align: {
        end: `${prefix}th--align-end`,
    },
    states: {
        focus: `${prefix}th--action-focus`,
    },
    withAction: `${prefix}th--action`,
    buttonScreenReader: `${prefix}th__button-sr`,
    resizeHandle: `${prefix}th__resize-handle`,
    pinIcon: `${prefix}th__pin-icon`,
    unpinIcon: `${prefix}th__unpin-icon`,
    sortIcon: `${prefix}th__sort-icon`,
    actionMenu: `${prefix}th__action-menu`,
    actionButton: {
        rest: `${prefix}th__button`,
        label: `${prefix}th__button-label`,
        icon: `${prefix}th__button-icon`,
    },
});

export const views = Object.freeze({
    rest: {
        attrs: { role: "columnheader" },
        classList: [componentClasses.basic, `!${componentClasses.states.focus}`],
    },
    withAction: {
        attrs: { role: "columnheader" },
        classList: [componentClasses.basic, componentClasses.withAction],
    },
    align: {
        end: {
            classList: [componentClasses.align.end],
        },
    },
    states: {
        focus: {
            classList: [componentClasses.states.focus],
        },
    },
    sortBy: {
        wrapper: {
            unsorted: {
                attrs: { "aria-sort": "none" },
            },
            ascending: {
                attrs: { "aria-sort": "ascending" },
            },
            descending: {
                attrs: { "aria-sort": "descending" },
            },
        },
        actionMenu: {
            unsorted: {
                attrs: { "aria-checked": "true" },
            },
            ascending: {
                attrs: { "aria-checked": "true" },
            },
            descending: {
                attrs: { "aria-checked": "true" },
            },
            unchecked: {
                attrs: { "aria-checked": "false" },
            },
        },
    },
});

/**
 * This object is to map every label we might have inside table head cell
 * It can be replaced by customers during the initialization, providing other labels if needed.
 */
export const defaultProps = Object.freeze({
    sort: {
        labels: {
            unsorted: "Unsorted",
            ascending: "Sorted in ascending order",
            descending: "Sorted in descending order",
        },
        actions: {
            unsorted: "Unsorted",
            ascending: "Sort ascending",
            descending: "Sort descending",
        },
    },
    pin: {
        pinLabel: "Pin column",
        unpinLabel: "Unpin column",
    },
});

export const eventMap = {
    sort: events.sort(componentName),
    pin: events.pin(componentName),
    unpin: events.unpin(componentName),
    headCellFocusChanged: events.headCellFocusChanged(componentName),
    resized: events.resized(componentName),
    styleUpdated: events.styleUpdated(componentName),
};

export const actions = Object.freeze({
    sort: {
        next: () => {
            return { type: actionTypes.next };
        },
        set: (value) => {
            return { type: actionTypes.set, value };
        },
    },
    pin: () => {
        return { type: types.true };
    },
    unpin: () => {
        return { type: types.false };
    },
});

//Defines the iterator of states for the sortButton
//which is "unsorted","ascending","descending"
export const sortState = new Set([sortType.unsorted, sortType.ascending, sortType.descending]);
